import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { readInlineData } from "react-relay";

import { ScheduleOption } from "../hooks/useGetScheduleSwitcherOptions";
import { facilityToScheduleOption_facility$key } from "./__generated__/facilityToScheduleOption_facility.graphql";

export const facilityToScheduleOption = (
  facilityRef: facilityToScheduleOption_facility$key | null
): ScheduleOption => {
  const facility = readInlineData(facilityToOptionFragmentString, facilityRef);
  return {
    type: "facility" as const,
    label: facility?.type === "DINING" ? t`Dining` : facility?.name || "",
    id: facility?.id || "",
    slug: facility?.type === "DINING" ? "dining" : facility?.slug || "",
    departmentType: facility?.department?.type || "GOLF",
  };
};

const facilityToOptionFragmentString = graphql`
  fragment facilityToScheduleOption_facility on Facility @inline {
    id
    slug
    name
    type
    department {
      type
    }
  }
`;
